module.exports = __webpack_public_path__ + "img/red_bull_racing.513887ba.png";